export default __webpack_public_path__ + "db7a12eedb16bd64eafee735a3814d49.png";